import { Component, inject } from '@angular/core';
import {EditingService} from '../../services/editing.service';
import {LoginService} from '../../services/login.service';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import firebase from 'firebase/compat/app';
import { RouterLink } from '@angular/router';
import { NgClass, AsyncPipe } from '@angular/common';
import 'firebase/compat/auth';

@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.scss'],
    imports: [NgClass, RouterLink, AsyncPipe]
})
export class NavComponent {
  private editService = inject(EditingService);
  loginService = inject(LoginService);
  afAuth = inject(AngularFireAuth);

  menuOpen = false;

  toggleEditMode() {
    this.editService.toggleEditMode();
  }

  login() {
    firebase.auth().signInWithPopup(new firebase.auth.GoogleAuthProvider());
  }
  logout() {
    firebase.auth().signOut();
  }
}

